import React from 'react';
import { Typography } from 'antd';
import JsonViewer from '../Common/JsonViewer';

const { Paragraph, Text, Title } = Typography;

/** Long-form explanation, shown in the form's help drawer. */
const HealthcheckHelp = () => (
    <Typography>
        <Paragraph>
            A healthcheck asks whether a service item is still operating normally. You implement the endpoint;
            NetOrca calls it on a schedule or when someone triggers it, and records the answer against each
            service item.
        </Paragraph>

        <Title level={5}>What NetOrca sends</Title>
        <Paragraph>Triggered for a whole service:</Paragraph>
        <JsonViewer
            data={{
                service: 'service.name',
                service_items: [
                    {
                        id: 'service_item_1.id',
                        name: 'service_item_1.name',
                        application: 'service_item_1.application.name',
                        consumer: 'service_item_1.application.owner.name',
                    },
                    {
                        id: 'service_item_2.id',
                        name: 'service_item_2.name',
                        application: 'service_item_2.application.name',
                        consumer: 'service_item_2.application.owner.name',
                    },
                ],
            }}
            fontSize="13px"
            lineHeight="1.6"
        />
        <Paragraph style={{ marginTop: 12 }}>Triggered for a single service item:</Paragraph>
        <JsonViewer
            data={{
                service: 'service.name',
                service_item: 'service_item.name',
                application: 'service_item.application.name',
                consumer: 'service_item.application.owner.name',
            }}
            fontSize="13px"
            lineHeight="1.6"
        />

        <Title level={5}>What NetOrca expects back</Title>
        <Paragraph>
            For a service-wide check, reply with one entry per service item, keyed by the id NetOrca assigned
            it. <Text code>200</Text> means healthy, <Text code>400</Text> means unhealthy:
        </Paragraph>
        <JsonViewer
            data={{
                service_item_1_id: { status_code: 200, body: { key: 'value' } },
                service_item_2_id: { status_code: 400, body: { key: 'value' } },
            }}
            fontSize="13px"
            lineHeight="1.6"
        />
        <Paragraph style={{ marginTop: 12 }}>
            For a single service item, the HTTP status of your response decides its health directly.
        </Paragraph>

        <Title level={5}>Responses</Title>
        <Paragraph>
            Every run is recorded per service item under the Responses tab on the healthchecks list. Only the
            last few responses are kept, and manual triggers are limited to three per minute. Authentication
            goes in the <Text code>Authorization</Text> header — for example{' '}
            <Text code>Api-Key &lt;key&gt;</Text>, <Text code>Token &lt;token&gt;</Text> or{' '}
            <Text code>Bearer &lt;jwt&gt;</Text>.
        </Paragraph>
    </Typography>
);

export default HealthcheckHelp;
